import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {LoadingStyledNewsItem, LoadingStyledNewsItemThumb, LoadingStyledNewsItemTitle} from "../../../utils/loading-styles";
import {NewsListContainer} from "../../../utils/common-styles";
import {HomeSectionTitle, HomeSectionType} from "../../../utils/common-styles";

export const LoadingHomeNewsList = () => {
    
    return (
        <>  
        <NewsListContainer>
            <HomeSectionTitle><strong>Our Latest   ____</strong></HomeSectionTitle>
            <HomeSectionType><h2>News Posts</h2></HomeSectionType>
            {[...Array(3)].map((_, index) => (
            <div key={index}>
                <LoadingStyledNewsItem>
                    <Row>
                        <Col xs={12} md={6}>
                            <LoadingStyledNewsItemThumb>
                                &nbsp;
                            </LoadingStyledNewsItemThumb>
                        </Col>
                        <Col xs={12} md={6}>
                            <LoadingStyledNewsItemTitle>
                                <h5>&nbsp;</h5>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                            </LoadingStyledNewsItemTitle>
                        </Col>
                    </Row>
                </LoadingStyledNewsItem>
            </div>
        ))}
        </NewsListContainer>
        </>
    )
}
